import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <Section background="light-peach" containerSize="md" className="text-center" data-id="element-118">
      <motion.div className="bg-white p-8 rounded-3xl border-2 border-fuchsia-200 inline-block shadow-xl" whileHover={{
      scale: 1.02
    }} data-id="element-119">
        <ShieldCheck className="w-16 h-16 text-fuchsia-500 mx-auto mb-4" data-id="element-120" />
        <h2 className="text-2xl font-black text-slate-900 mb-4" data-id="element-121">
          Probalo sin riesgo
        </h2>
        <p className="text-lg text-slate-700 max-w-lg mx-auto mb-2" data-id="element-122">
          Tenés 7 días para probar ENERGÍA REAL. Si no es para vos, te
          devolvemos el 100%.
        </p>
        <p className="font-bold text-fuchsia-600" data-id="element-123">Sin vueltas.</p>
      </motion.div>
    </Section>;
}